import React from 'react';
import { CustomFieldsPanel } from './CustomFieldsPanel';
import { useCustomFieldsWidgetContext } from '../CustomFieldsWidgetContext';

export function CustomFieldsPanelEntry() {
  const state = useCustomFieldsWidgetContext();

  return <CustomFieldsPanel state={state.customFieldsPanel} />;
}
